import AddIcon from '@mui/icons-material/Add';
import ValidateIcon from '@mui/icons-material/AssignmentTurnedIn';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { lighten } from '@mui/material/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from 'tss-react/mui';

const styles = (theme) => ({
  root: {
    paddingRight: theme.spacing(1),
    minHeight: 30,
  },
  highlight:
    theme.palette.mode === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  newButton: {},
});

const QListToolbar = (props) => {
  const { numSelected, classes, onDelete, onRequestCreate, onValidateRequest, listName } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 && (
          <Typography color='inherit' variant='titleRegular'>
            {numSelected} selected
          </Typography>
        )}
      </div>
      {numSelected === 0 && (
        <>
          <Tooltip title='Create new item'>
            <IconButton
              aria-label='Create New Item'
              color='primary'
              className={classes.newButton}
              onClick={onRequestCreate}
              id={`create-new-${listName}`}
              size='large'
            >
              <AddIcon viewBox='0 0 24 24' />
            </IconButton>
          </Tooltip>
          {onValidateRequest && (
            <Tooltip title='Validate Data'>
              <IconButton
                aria-label='Validate Data'
                color='primary'
                className={classes.newButton}
                onClick={onValidateRequest}
                id={`validate-${listName}`}
                size='large'
              >
                <ValidateIcon viewBox='-3 -5 30 30' />
              </IconButton>
            </Tooltip>
          )}
        </>
      )}

      <div className={classes.spacer} />

      <div className={classes.actions}>
        {numSelected > 0 ? (
          <Tooltip title='Delete'>
            <IconButton aria-label='Delete' onClick={onDelete} id='delete-button' size='large'>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <div>
            <Tooltip title='Filter list'>
              <IconButton aria-label='Filter list' id='filter-button' size='large'>
                <FilterListIcon />
              </IconButton>
            </Tooltip>
          </div>
        )}
      </div>
    </Toolbar>
  );
};

QListToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onDelete: PropTypes.func,
  onRequestCreate: PropTypes.func,
  onValidateRequest: PropTypes.func,
  listName: PropTypes.string,
};

export default withStyles(QListToolbar, styles);
